module.exports = __webpack_public_path__ + "img/address-details-active.eb8732d0.svg";